module.exports = __webpack_public_path__ + "Icono_Buscar_blue_512px.png";